<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <base-alert type="warning" dismissible>
          {{$t('medium_grant.technical__1_editable_version')}}
          <div class="mt-2">
            <a :href="downloadFiles[$i18n.locale]" class="link-download-white" target="_blank">{{$t('medium_grant.technical__1_editable_version_download')}}
              <img class="ml-2" width="25" src="/img/icons/doc-white.png"> </a>
          </div>
        </base-alert>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('medium_grant.technical__1_overview')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.titleOfProject"
            v-model="GrantForm.title"
            :error="getError('technical.titleOfProject')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_title_of_project')"
            :label="$t('medium_grant.technical__1_title_of_project')"
            :placeholder="$t('medium_grant.technical__1_title_of_project')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__1_region')}}</label> <select class="form-control"
                                                                                               @change="setRegion"
                                                                                               name="technical.region"
                                                                                               id="regionSelect"
                                                                                               :error="getError('technical.region')"
                                                                                               v-validate="'required'"
                                                                                               :data-vv-as="$t('medium_grant.technical__1_region')"
                                                                                               disabled
        >
          <option value="" selected="selected">{{$t('medium_grant.general__please_select')}}</option>
          <option :value="region.regionId" :selected="GrantForm.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
        </select>
          <label v-if="getError('technical.region')" class="error text-danger">{{getError('technical.region')}}</label>
        </div>

        <div class="form-group" :class="{'has-danger': getError('technical.acpCountry')}">
          <label for="countrySelect">{{$t('medium_grant.technical__1_acp_country')}}</label>
          <multiselect name="technical.acpCountry" v-model="GrantForm.model.technical.acpCountry" selectLabel="" selectedLabel="" deselectLabel="Clear" v-validate="'required'" :data-vv-as="$t('medium_grant.technical__1_acp_country')" :tag-placeholder="$t('medium_grant.general__please_select')" :placeholder="$t('medium_grant.general__please_select')" label="name" track-by="countryId" :options="countriesByRegion" :multiple="true"></multiselect>
          <label v-if="getError('technical.acpCountry')" class="error text-danger">{{getError('technical.acpCountry')}}</label>
        </div>

        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.priorityLandscape"
            v-model="GrantForm.model.technical.priorityLandscape"
            :error="getError('technical.priorityLandscape')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_priority_landscape')"
            :label="$t('medium_grant.technical__1_priority_landscape')"
            :placeholder="$t('medium_grant.technical__1_priority_landscape')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.paTarget"
            v-model="GrantForm.model.technical.paTarget"
            :error="getError('technical.paTarget')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_pa_target')"
            :label="$t('medium_grant.technical__1_pa_target')"
            :placeholder="$t('medium_grant.technical__1_pa_target')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.paSupervisory"
            v-model="GrantForm.model.technical.paSupervisory"
            :error="getError('technical.paSupervisory')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_pa_supervisory')"
            :label="$t('medium_grant.technical__1_pa_supervisory')"
            :placeholder="$t('medium_grant.technical__1_pa_supervisory')"
          >
          </textarea>
        </div>
        <div class="mb-3">
          <p>{{$t('medium_grant.technical__1_pa_supervisory_upload')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.supervisoryUpload" :file-data="GrantForm.files.technical.supervisoryUpload" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="technical.supervisoryUpload"></upload-file>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.nameOfLeadOrg"
            v-model="GrantForm.model.technical.nameOfLeadOrg"
            :error="getError('technical.nameOfLeadOrg')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_name_lead_org')"
            :label="$t('medium_grant.technical__1_name_lead_org')"
            :placeholder="$t('medium_grant.technical__1_name_lead_org')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.nameOfCoApplicants"
            v-model="GrantForm.model.technical.nameOfCoApplicants"
            :label="$t('medium_grant.technical__1_name_of_co_app')"
            :placeholder="$t('medium_grant.technical__1_name_of_co_app')"
          >
          </textarea>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              name="technical.startDate"
              v-model="GrantForm.model.technical.startDate"
              :error="getError('technical.startDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_startdate')"
              :placeholder="$t('medium_grant.technical__1_startdate')"
            >
              <label>{{$t('medium_grant.technical__1_startdate')}}</label>
              <el-date-picker
                type="date"
                v-model="startDate"
                :placeholder="$t('medium_grant.technical__1_startdate')"
              >
              </el-date-picker>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              name="technical.endDate"
              v-model="GrantForm.model.technical.endDate"
              :placeholder="$t('medium_grant.technical__1_enddate')"
              :error="getError('technical.endDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_enddate')"
            >
              <label>{{$t('medium_grant.technical__1_enddate')}}</label>
              <el-date-picker
                type="date"
                v-model="endDate"
                :placeholder="$t('medium_grant.technical__1_enddate')"
              >
              </el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.duration"
            v-model="GrantForm.model.technical.duration"
            :error="getError('technical.duration')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_duration')"
            :label="$t('medium_grant.technical__1_duration')"
            :placeholder="$t('medium_grant.technical__1_duration')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.totalBudget"
            v-model="GrantForm.model.technical.totalBudget"
            :error="getError('technical.totalBudget')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_budget')"
            :label="$t('medium_grant.technical__1_total_budget')"
            :placeholder="$t('medium_grant.technical__1_total_budget')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.totalFunding"
            v-model="GrantForm.model.technical.totalFunding"
            :error="getError('technical.totalFunding')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_funding')"
            :label="$t('medium_grant.technical__1_total_funding')"
            :placeholder="$t('medium_grant.technical__1_total_funding')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.totalCoFunding"
            v-model="GrantForm.model.technical.totalCoFunding"
            :error="getError('technical.totalCoFunding')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_cofunding')"
            :label="$t('medium_grant.technical__1_total_cofunding')"
            :placeholder="$t('medium_grant.technical__1_total_cofunding')"
          >
          </textarea>
        </div>
      </div>
      <div class="col-lg-4">
        <h6>
          {{$t('medium_grant.technical__1_biopama_action')}}
        </h6>
        <div class="mt-4"></div>
        <base-checkbox name="checkbox" v-model="GrantForm.model.technical.enhaceManagement">
          {{$t('medium_grant.technical__1_enhace_management')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.technical.enforceLegal">
          {{$t('medium_grant.technical__1_enforce_legal')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.technical.supportLocal">
          {{$t('medium_grant.technical__1_support_local')}}
        </base-checkbox>
        <div class="mt-4"></div>
        <div>
          <label>{{$t('medium_grant.technical__1_priorities_for_action')}}</label>
        </div>
        <div>
          <label>{{$t('medium_grant.technical__1_priorities_for_action_sub')}}</label>
        </div>
        <textarea
          class="form-control"
          :placeholder="$t('medium_grant.technical__1_please_indicate')"
          v-model="GrantForm.model.technical.indicatePriorities"
        >
        </textarea>
        <div class="mt-4">
          <label class="mb-3">{{$t('medium_grant.technical__1_project_enable_data_sharing')}}</label>
          <radio name="organisationType"
                 inline
                 :value="true"
                 v-model="GrantForm.model.technical.enableDataSharing"
          >
            {{$t('medium_grant.technical__1_project_enable_data_sharing_yes')}}
          </radio>
          <radio name="organisationType" inline :value="false" v-model="GrantForm.model.technical.enableDataSharing">
            {{$t('medium_grant.technical__1_project_enable_data_sharing_no')}}
          </radio>
        </div>
      </div>
      <div class="col-lg-4">
        <h6>
          {{$t('medium_grant.technical__1_reference_doc')}}
        </h6>
        <div class="mt-4"></div>
        <base-checkbox name="checkbox" v-model="GrantForm.model.technical.managementGov">
          {{$t('medium_grant.technical__1_management_gov')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.technical.strategicDoc">
          {{$t('medium_grant.technical__1_strategic_doc')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.technical.thematic">
          {{$t('medium_grant.technical__1_thematic')}}
        </base-checkbox>
        <textarea
          class="form-control"
          :placeholder="$t('medium_grant.technical__1_please_indicate')"
          v-model="GrantForm.model.technical.pleaseIndicate"
        >
        </textarea>
      </div>
    </div>
  </form>
</template>
<script>
  import {DatePicker} from 'element-ui';
  import Multiselect from 'vue-multiselect';
  import {GrantForm, RegionService} from "@/services";
  import {BaseAlert} from 'src/components';

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      Multiselect,
      BaseAlert
    },
    data() {
      return {
        GrantForm,
        startDate: '',
        endDate: '',
        moment: '',
        regions: [],
        options: [],
        value: [],
        downloadFiles: {
          en: '/files/en/Application_template_BIOPAMA_medium_grants_2019_EN.docx',
          fr: '/files/fr/Application_template_BIOPAMA_medium_grants_2019_FR.docx'
        }
      }
    },
    computed: {
      countriesByRegion() {
        let countries = [];
        let region = this.regions.filter((region) => {
          return region.regionId === GrantForm.regionId;
        })
        if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length) {
          countries = region[0].countries;
        }
        return countries;
      }
    },
    async beforeMount() {
      this.moment = require('moment');

      let loader = this.$loading.show();
      let vm = this;
      RegionService.getApplicationRegionsWithCountries().then(function (response) {
        vm.regions = response.data;

        loader.hide();
      })

      if (GrantForm.model.technical.startDate !== undefined) {
        this.startDate = GrantForm.model.technical.startDate;
      }

      if (GrantForm.model.technical.endDate !== undefined) {
        this.endDate = GrantForm.model.technical.endDate;
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      setRegion(event) {
        GrantForm.regionId = parseInt(event.target.value);
        GrantForm.model.technical.acpCountry = [];
      }
    },
    watch: {
      startDate(newValue, oldValue) {
        GrantForm.model.technical.startDate = this.moment(newValue).format('YYYY-MM-DD');
      },
      endDate(newValue, oldValue) {
        GrantForm.model.technical.endDate = this.moment(newValue).format('YYYY-MM-DD');
      }
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
